// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1CgLB","footer":"ModalFilter_footer__2GHPX"};